import { VerificationType } from '@entities/Authentication/types.ts';
import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';

type DataT = {
  isOpen: boolean;
  onSuccess?: () => void;
  phonenumber: string;
  number?: string;
  passcode?: string;
  disableOverlayCss?: boolean;
  onClose?: () => void;
  verification_type?: VerificationType;
};

export const usePhoneVerificationIncomingModal = () => {
  const {
    data: state,
    doRemoveStorageData,
    doSetStorageData,
  } = useSaveData<DataT>('phoneVerificationIncomingModalState');

  const openPhoneVerificationIncomingModal = useCallback(
    ({
      passcode = 'unknown',
      number = 'unknown',
      verification_type = 'registration',
      ...rest
    }: Omit<DataT, 'isOpen'>) =>
      doSetStorageData({
        isOpen: true,
        number,
        passcode,
        verification_type,
        ...rest,
      }),
    [doSetStorageData]
  );

  const closePhoneVerificationIncomingModal = useCallback(
    ({ isSuccess }: { isSuccess: boolean }) => {
      doRemoveStorageData();
      isSuccess && state?.onSuccess?.();
      state?.onClose && state.onClose();
    },
    [doRemoveStorageData, state]
  );

  return {
    state,
    openPhoneVerificationIncomingModal,
    closePhoneVerificationIncomingModal,
  };
};
